import {http} from "../http";

export interface GetLastLogin{
    LAST_LOGIN_DATE : string;
    LAST_LOGIN_TIME : string;
}


export const getLastLoginList = async (): Promise<GetLastLogin> => {
    const { data } = await http.get<GetLastLogin>("auth/getlastlogin");
    return data;
};


